export default __webpack_public_path__ + "static/media/img-0595-poland-premium-face.2bd39c1b.png";